import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PhoneDialerComponent } from './phone-dialer.component';

const routes: Routes = [{ path: '', component: PhoneDialerComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PhoneDialerRoutingModule { }
